module.exports = __webpack_public_path__ + "static/img/img02.6970904.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/en/en018/img02.jpg
// module id = kR9J
// module chunks = 0